module.exports = __webpack_public_path__ + "media/customizations/nolina/logo-55c53c9a59a9b20c48931bab3aa68e8a.png";